window.Sparkle ??= {};
window.Sparkle.MobileCTA ??= {};

Object.assign(window.Sparkle.MobileCTA, {
  renderModalTeaser: (components, appendToSelector, replace) => {
    if (replace && !components.length) {
      Sparkle.MobileCTA.clearModalTeaser();
      return;
    }

    if (!components.length) {
      return;
    }

    return Sparkle.MobileCTA.createTeaser(appendToSelector).then((teaserBar) => {
      if (replace) {
        teaserBar.el.empty();
      }
      if (!teaserBar.allowAdd()) {
        return;
      }

      return components.each((index, callToAction) => {
        const cta = new Sparkle.MobileCTA.Modal(callToAction, appendToSelector);
        return teaserBar.add(cta.truncatedTitle(), cta.elementType, cta.activate);
      });
    });
  },

  renderSpComponentModalTeaser: (spComponentCTAs, spComponentSelector, appendToSelector) => {
    if (!spComponentCTAs.length) {
      return;
    }
    const spComponents = spComponentCTAs.find(spComponentSelector);

    return Sparkle.MobileCTA.createTeaser(appendToSelector).then((teaserBar) => {
      if (!teaserBar.allowAdd()) {
        return;
      }

      return spComponents.each((index, spComponent) => {
        const activator = spComponent.ctaActivator;
        if (activator) {
          return teaserBar.addSpComponent(activator);
        }
      });
    });
  },

  renderInlineTeaser: (components, appendToSelector) => {
    if (!components.length) {
      return;
    }

    return jQuery.when().then(() => {
      const teaserInline = new Sparkle.MobileCTA.TeaserInline(appendToSelector);

      return components.each((index, callToAction) => {
        const cta = new Sparkle.MobileCTA.Inline(callToAction);
        return teaserInline.add(cta.truncatedTitle(), cta.klass, cta.activate);
      });
    });
  },

  createTeaser: (appendToSelector) =>
    jQuery.when().then(() => {
      const teaserBar = Sparkle.MobileCTA.currentTeaserBar;
      if (Sparkle.MobileCTA.currentTeaserBar) {
        if (teaserBar.el.parent(appendToSelector)) {
          return teaserBar;
        }
      }

      Sparkle.MobileCTA.currentTeaserBar = new Sparkle.MobileCTA.TeaserBar(appendToSelector);
      return Sparkle.MobileCTA.currentTeaserBar;
    }),

  clearModalTeaser: () => {
    Sparkle.MobileCTA.currentTeaserBar?.el.empty();
    jQuery(".mobile-cta-sticky-teaser-wrapper").empty();
  },
});
